(function () {
  'use strict';

  function AccessoriesSelection(root) {
    this.root = root;
    this.cartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
    this.cartChangeUrl = root.getAttribute('data-cart-change-url') || '/cart/change';
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-accessories-tab]'));
    this.tracks = Array.prototype.slice.call(root.querySelectorAll('[data-accessories-track]'));
    this.dotsWrap = root.querySelector('[data-accessories-dots]');
    this.prevBtn = root.querySelector('[data-accessories-prev]');
    this.nextBtn = root.querySelector('[data-accessories-next]');
    this.viewport = root.querySelector('.accessories-selection__viewport');

    this.autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
    this.autoplaySpeed = parseFloat(root.getAttribute('data-autoplay-speed')) || 4;
    this.autoplayTimer = null;

    if (!this.tracks.length) return;

    this.activeTrack = this.tracks.filter(function (track) {
      return !track.classList.contains('is-hidden');
    })[0] || this.tracks[0];

    this.bindTabs();
    this.bindCartControls();
    this.bindScroll();
    this.bindArrows();
    this.buildDots();
    this.updateArrows();

    if (this.autoplayEnabled) {
      this.bindAutoplay();
    }
  }

  AccessoriesSelection.prototype.cardsIn = function (track) {
    return Array.prototype.slice.call(track.querySelectorAll('[data-accessories-card]'));
  };

  AccessoriesSelection.prototype.columnsPerView = function () {
    var width = window.innerWidth;
    if (width <= 480) return 1;
    if (width <= 989) return 2;
    return 4;
  };

  AccessoriesSelection.prototype.bindTabs = function () {
    var self = this;
    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.getAttribute('data-tab-index');

        self.tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        self.tracks.forEach(function (track) {
          var isTarget = track.getAttribute('data-tab-index') === index;
          track.classList.toggle('is-hidden', !isTarget);
          if (isTarget) self.activeTrack = track;
        });

        self.activeTrack.scrollTo({ left: 0, behavior: 'auto' });
        self.buildDots();
        self.updateArrows();

        if (self.autoplayEnabled) {
          self.startAutoplay();
        }
      });
    });
  };

  // ---------------------------------------------------------------------
  // Cart controls: Add to Cart button <-> quantity stepper (- / count / +)
  // ---------------------------------------------------------------------

  AccessoriesSelection.prototype.bindCartControls = function () {
    var self = this;
    var wraps = this.root.querySelectorAll('[data-accessories-cart-wrap]');

    wraps.forEach(function (wrap) {
      var form = wrap.querySelector('[data-accessories-add-form]');
      var addButton = wrap.querySelector('[data-accessories-add-button]');
      var stepper = wrap.querySelector('[data-accessories-stepper]');
      var countEl = wrap.querySelector('[data-accessories-count]');
      var decreaseBtn = wrap.querySelector('[data-accessories-decrease]');
      var increaseBtn = wrap.querySelector('[data-accessories-increase]');
      var variantId = wrap.getAttribute('data-variant-id');

      if (!form || !stepper || !countEl || !variantId) return;

      var busy = false;

      function showForm() {
        stepper.hidden = true;
        form.hidden = false;
      }

      function showStepper(quantity) {
        countEl.textContent = quantity;
        form.hidden = true;
        stepper.hidden = false;
      }

      function setBusy(state) {
        busy = state;
        if (decreaseBtn) decreaseBtn.disabled = state;
        if (increaseBtn) increaseBtn.disabled = state;
        if (addButton) addButton.disabled = state;
      }

      function changeQuantity(newQuantity) {
        if (busy) return;
        setBusy(true);

        fetch(self.cartChangeUrl.replace(/\.js$/, '') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: newQuantity })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart update failed');
            return response.json();
          })
          .then(function () {
            setBusy(false);
            if (newQuantity <= 0) {
              showForm();
            } else {
              showStepper(newQuantity);
            }
          })
          .catch(function (error) {
            console.error('[Accessories selection] Cart update failed:', error.message);
            setBusy(false);
          });
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!addButton || addButton.disabled || busy) return;

        setBusy(true);
        var originalText = addButton.textContent;
        addButton.textContent = 'Adding…';

        var addUrl = self.cartAddUrl.replace(/\/$/, '') + '.js';

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: form.querySelector('input[name="id"]').value,
            quantity: 1
          })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (errorData) {
                throw new Error((errorData && errorData.description) || 'Cart add failed');
              });
            }
            return response.json();
          })
          .then(function (lineItem) {
            setBusy(false);
            addButton.textContent = originalText;
            var quantity = (lineItem && lineItem.quantity) || 1;
            showStepper(quantity);
          })
          .catch(function (error) {
            console.error('[Accessories selection] Add to cart failed:', error.message);
            setBusy(false);
            addButton.textContent = 'Try again';
            window.setTimeout(function () {
              addButton.textContent = originalText;
            }, 1800);
          });
      });

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function () {
          var current = parseInt(countEl.textContent, 10) || 1;
          changeQuantity(current - 1);
        });
      }

      if (increaseBtn) {
        increaseBtn.addEventListener('click', function () {
          var current = parseInt(countEl.textContent, 10) || 1;
          changeQuantity(current + 1);
        });
      }
    });
  };

  AccessoriesSelection.prototype.buildDots = function () {
    if (!this.dotsWrap) return;
    var self = this;
    var cards = this.cardsIn(this.activeTrack);
    var perView = this.columnsPerView();
    var pageCount = Math.ceil(cards.length / perView) || 1;

    this.dotsWrap.innerHTML = '';
    if (pageCount <= 1) return;

    for (var i = 0; i < pageCount; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'accessories-selection__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
      (function (pageIndex) {
        dot.addEventListener('click', function () {
          self.scrollToPage(pageIndex);
        });
      })(i);
      this.dotsWrap.appendChild(dot);
    }
  };

  AccessoriesSelection.prototype.scrollToPage = function (pageIndex) {
    var cards = this.cardsIn(this.activeTrack);
    var perView = this.columnsPerView();
    var targetCard = cards[pageIndex * perView];
    if (!targetCard) return;
    this.activeTrack.scrollTo({ left: targetCard.offsetLeft - this.activeTrack.offsetLeft, behavior: 'smooth' });
  };

  AccessoriesSelection.prototype.bindArrows = function () {
    var self = this;
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.step(-1);
        if (self.autoplayEnabled) self.startAutoplay();
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.step(1);
        if (self.autoplayEnabled) self.startAutoplay();
      });
    }
  };

  AccessoriesSelection.prototype.step = function (direction) {
    var cards = this.cardsIn(this.activeTrack);
    if (!cards.length) return;
    var perView = this.columnsPerView();
    var currentIndex = this.currentIndex();
    var targetIndex = currentIndex + direction * perView;
    targetIndex = Math.max(0, Math.min(targetIndex, cards.length - 1));
    var targetCard = cards[targetIndex];
    if (!targetCard) return;
    this.activeTrack.scrollTo({ left: targetCard.offsetLeft - this.activeTrack.offsetLeft, behavior: 'smooth' });
  };

  AccessoriesSelection.prototype.currentIndex = function () {
    var cards = this.cardsIn(this.activeTrack);
    var scrollLeft = this.activeTrack.scrollLeft;
    var currentIndex = 0;
    cards.forEach(function (card, index) {
      if (card.offsetLeft - card.parentElement.offsetLeft <= scrollLeft + 8) {
        currentIndex = index;
      }
    });
    return currentIndex;
  };

  AccessoriesSelection.prototype.bindScroll = function () {
    var self = this;
    var ticking = false;

    this.tracks.forEach(function (track) {
      track.addEventListener('scroll', function () {
        if (track !== self.activeTrack) return;
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          self.updateActiveDot();
          self.updateArrows();
          ticking = false;
        });
      });
    });

    window.addEventListener('resize', function () {
      self.buildDots();
      self.updateArrows();
    });
  };

  AccessoriesSelection.prototype.updateActiveDot = function () {
    if (!this.dotsWrap) return;
    var perView = this.columnsPerView();
    var pageIndex = Math.floor(this.currentIndex() / perView);

    var dots = Array.prototype.slice.call(this.dotsWrap.querySelectorAll('.accessories-selection__dot'));
    dots.forEach(function (dot, index) {
      dot.classList.toggle('is-active', index === pageIndex);
    });
  };

  AccessoriesSelection.prototype.updateArrows = function () {
    var track = this.activeTrack;
    if (!track) return;
    var maxScroll = track.scrollWidth - track.clientWidth - 2;

    if (this.prevBtn) {
      this.prevBtn.disabled = track.scrollLeft <= 0;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = track.scrollLeft >= maxScroll || maxScroll <= 0;
    }
  };

  // ---------------------------------------------------------------------
  // Autoplay — advances the active track every N seconds (theme editor
  // setting), pauses on hover/touch and when the browser tab is hidden,
  // and loops back to the start once it reaches the end.
  // ---------------------------------------------------------------------

  AccessoriesSelection.prototype.bindAutoplay = function () {
    var self = this;

    this.startAutoplay();

    if (this.viewport) {
      this.viewport.addEventListener('mouseenter', function () {
        self.stopAutoplay();
      });
      this.viewport.addEventListener('mouseleave', function () {
        self.startAutoplay();
      });
      this.viewport.addEventListener('touchstart', function () {
        self.stopAutoplay();
      }, { passive: true });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        self.stopAutoplay();
      } else {
        self.startAutoplay();
      }
    });
  };

  AccessoriesSelection.prototype.startAutoplay = function () {
    var self = this;
    this.stopAutoplay();
    this.autoplayTimer = window.setInterval(function () {
      self.autoAdvance();
    }, this.autoplaySpeed * 1000);
  };

  AccessoriesSelection.prototype.stopAutoplay = function () {
    if (this.autoplayTimer) {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  };

  AccessoriesSelection.prototype.autoAdvance = function () {
    var track = this.activeTrack;
    if (!track) return;
    var maxScroll = track.scrollWidth - track.clientWidth - 2;

    if (maxScroll <= 0) return;

    if (track.scrollLeft >= maxScroll) {
      track.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      this.step(1);
    }
  };

  function init(scope) {
    scope.querySelectorAll('[data-accessories-selection]').forEach(function (root) {
      if (root.accessoriesInstance) return;
      root.accessoriesInstance = new AccessoriesSelection(root);
    });
  }

  init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();